import Axios from 'axios';
import { useQuery } from '@tanstack/react-query';

const model = 'usages';

export async function getUsagesStats({ tenantIds, startDate, endDate }) {
  const res = await Axios({
    method: 'POST',
    url: `${model}/stats`,
    data: {
      tenant_ids: tenantIds,
      created_at_from: new Date(startDate).toISOString(),
      created_at_to: new Date(endDate).toISOString()
    }
  });
  return res?.data;
}

export const useUsagesStats = ({ tenantIds, startDate, endDate }, queryOptions = {}) => {
  return useQuery({
    queryKey: [model, 'stats', tenantIds, startDate, endDate],
    queryFn: () => getUsagesStats({ tenantIds, startDate, endDate }),
    enabled: !!tenantIds?.length && !!startDate && !!endDate,
    ...queryOptions
  });
};
